import React, { Component } from "react";

class Confirmation extends Component {
  constructor(props) {
    super(props);

    this.create_account_confirmation_line_1 =
      window.create_account &&
      window.create_account.create_account_confirmation_line_1
        ? window.create_account.create_account_confirmation_line_1
        : "";

    this.create_account_confirmation_line_2 =
      window.create_account &&
      window.create_account.create_account_confirmation_line_2
        ? window.create_account.create_account_confirmation_line_2
        : "";
  }

  render() {
    return (
      <div className="create-account__confirmation">
        <div className="create-account__confirmation-icon">
          <i className="fa fa-check" aria-hidden="true" />
        </div>
        {this.create_account_confirmation_line_1 && (
          <p className="create-account__confirmation-text">
            <i className="fa fa-check-circle" aria-hidden="true" />
            {this.create_account_confirmation_line_1}
          </p>
        )}
        {this.create_account_confirmation_line_2 && (
          <p className="create-account__confirmation-text">
            <i className="fa fa-envelope" aria-hidden="true" />
            {this.create_account_confirmation_line_2}
          </p>
        )}
        <div className="create-account__confirmation-cta">
          <a href="/login" className="btn btn-medium btn-primary create-account__submit">
            Sign In Now
          </a>
        </div>
      </div>
    );
  }
}
export { Confirmation };
